import { useScroll } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import { val } from "@theatre/core";
import { PerspectiveCamera, useCurrentSheet } from "@theatre/r3f";
import Model from './Model.jsx';
import People4 from './People/People4.jsx';
import People3 from './People/People3.jsx';
import People5 from './People/People5.jsx';
import People6 from './People/People6.jsx';
import People7 from './People/People7.jsx';
import PeopleC from './People/PeopleC.jsx';
import PeopleD from './People/PeopleD.jsx';
import PeopleM from './People/PeopleM.jsx';
import PeopleG from './People/PeopleG.jsx';

import Tree from './Trees/Tree.jsx';

export default function Scene() {
  const sheet = useCurrentSheet();
  const scroll = useScroll();

  // our callback will run on every animation frame
  useFrame(() => {
    // the length of our sequence
    const sequenceLength = val(sheet.sequence.pointer.length);
    // update the "position" of the playhead in the sequence, as a fraction of its whole length
    sheet.sequence.position = scroll.offset * sequenceLength;
  });

  const bgColor = "#e6fdff"
  // const bgColor = "black"
  // const bgColor = "#444"

  return (
    <>
      <fog attach="fog" color={ bgColor } near={-4} far={50} />
      <ambientLight intensity={0.5} color={ '#fafae6' }  />
      <directionalLight position={[-25, 50, -5]} intensity={1.5} color={ '#fafae6' } />
      <Tree position={ [ 28.5, 2.25, -38.35 ] } scale={ 0.45 }  rotation={ [0, 1, 0 ] }/>
      <Tree position={ [ 29, 2.5, -38.75] } scale={ 0.5 }  rotation={ [0, 3, 0 ] }/>
      
      <Tree position={ [ 34, 2.375, -18.5] } scale={ 0.65 }  rotation={ [0, 3, 0 ] } />
      <Tree position={ [ 44.75, 2.75, -16.5] } scale={ 0.75 }  rotation={ [0, 1, 0 ] } />
      
      <Tree position={ [ 8.5, 2, -12.5] } scale={ 0.45 }  rotation={ [0, 5, 0 ] } />
      <Tree position={ [ -6, 1.5, -18] } scale={ 0.5 }  rotation={ [0, 1, 0 ] } />

      <PeopleG scale={0.5} rotation={ [0, 0, 0 ] } position={ [ 28.5, 2.375, -27.5] } />
      <PeopleC scale={0.5} rotation={ [0, 4, 0 ] } position={ [ 26.5, 2.375, -26.5] } />
      <PeopleD scale={0.5} rotation={ [0, 1, 0 ] } position={ [ 24.5, 2.375, -25.5] } />
      <PeopleM scale={0.5} rotation={ [0, 4.75, 0 ] } position={ [ 34.5, 2.65, -24.5] } />


      <People3 scale={0.5} rotation={ [0, 0, 0 ] } position={ [ 24, 2.375, -27 ] } />
      <People4 scale={0.5} rotation={ [0, 40, 0 ] } position={ [ 25, 2.5, -24 ] } />
      <People5 scale={0.5} rotation={ [0, 10, 0 ] } position={ [ 26, 2.5, -24 ] } />
      <People6 scale={0.5} rotation={ [0, 11, 0 ] } position={ [ 20, 2.375, -26 ] } />
      <People7 scale={0.5} rotation={ [0, 11, 0 ] } position={ [ 27.375, 2.3, -27.5 ] } />
      <Model />
      <PerspectiveCamera
        theatreKey="Camera"
        makeDefault
        position={[0, 0, 0]}
        fov={40}
        near={0.1}
        far={70}
      />
    </>
  );
}